import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button } from '@mui/material';
import type { ArrayHelpers } from 'formik';

import type { FormField } from 'src/types/survey';

import { styles } from 'src/components/survey/SurveySettings/index.styles';

interface AddNewFormFieldProps extends Pick<ArrayHelpers, 'push'> {
  fields: Array<FormField>;
}

const AddNewFormField: FC<AddNewFormFieldProps> = ({ push, fields }) => {
  const { t } = useTranslation('survey');
  return (
    <Box sx={styles.formFieldEdit}>
      <Box sx={styles.addNewFormField}>
        <Button
          variant="cta"
          color="secondary"
          onClick={() =>
            push({
              name: '',
              description: '',
              isActive: false,
              isMandatory: false,
              id: -1 - fields.length,
            })
          }
        >
          {t('settings.followUpModule.addFormField')}
        </Button>
      </Box>
    </Box>
  );
};
export default AddNewFormField;
